import * as Yup from "yup";
import Alert from "../../utils/Alert.js";
import { loginService } from "../../services/authServices.js";
import { tokenDecoder } from "../../utils/tokenDecoder.js";

export const initialValues = {
    email_or_phone: "",
    password: ""
};

export const onSubmit = async (values, actions, navigate) => {
    try {
        const response = await loginService(values);
        if (response.status === 200) {
            const decodedToken = tokenDecoder(response.data.access);
            const finalToken = {
                ...response.data,
                expireDate: decodedToken.exp * 1000,
                userRole: decodedToken.user_role,
                userId: decodedToken.user_id,
            };
            localStorage.setItem("cncToken", JSON.stringify(finalToken));
            return navigate("/");
        }
    } catch (error) {
        if(error.response && error.response.status === 404) {
            Alert(`خطا ${error.response.status}!`, "ایمیل یا شماره تلفن اشتباه وارد شده است.", "error");
        } 
        else if(error.response && error.response.status === 401) {
            Alert(`خطا ${error.response.status}!`, "رمز عبور نادرست می‌باشد.", "error");
        }
    }
};

export const validationSchema = Yup.object({
    email_or_phone: Yup.string().required("لطفاً ایمیل یا شماره تلفن را وارد کنید")
        .matches(/(^[a-zA-Z0-9._-]+@[a-zA-Z.]+\.[a-zA-Z]{2,}$)|(^[0-9]{11}$)/, "لطفاً یک ایمیل یا شماره تلفن معتبر وارد کنید"),
    password: Yup.string().required("لطفاً رمز عبور را وارد کنید")
        .matches(/^[a-zA-Z0-9_]+$/, "داخل رمز از نمادها و فاصله استفاده نکنید")
});